module.exports = __webpack_public_path__ + "static/media/Shallots.8e51d2a4.png";